import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { GridTabDirectionService } from 'src/app/stocks/shared/grid-tab-direction.service';

/**
 * Tab 方向切換元件
 * 用於切換 Grid 編輯模式的 Tab 導航方向（向右/向下）
 */
@Component({
  selector: 'app-stocks-tab-direction-toggle',
  templateUrl: './tab-direction-toggle.component.html',
  styleUrls: ['./tab-direction-toggle.component.css']
})
export class TabDirectionToggleComponent implements OnInit {
  /** 當前 Tab 方向 */
  direction: 'down' | 'right' = 'right';

  /** 是否禁用 */
  @Input() disabled: boolean = false;

  /** 將 disabled 狀態綁定為 host 的 class */
  @HostBinding('class.disabled') get isDisabled() { return this.disabled; }

  constructor(private gridTabDirectionService: GridTabDirectionService) {}

  ngOnInit() {
    // 從 Service 取得當前方向（跨頁面保留）
    this.direction = this.gridTabDirectionService.getDirection();
  }

  /**
   * 方向變更時同步更新 Service
   */
  onDirectionChange(value: 'down' | 'right') {
    this.gridTabDirectionService.setDirection(value);
  }
}
